import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Business Sales Growth',
    description: 'Accelerate your sales growth with strategic business development. Our services include market analysis, strategy formulation, and execution plans to boost revenue.',
  },
  {
    icon: <FaLock />,
    title: 'Mergers & Acquisitions',
    description: 'Navigate mergers and acquisitions with expert guidance. We offer support throughout the process to ensure successful transitions and growth opportunities.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Project Management',
    description: 'Ensure project success with professional project management. We handle planning, execution, and monitoring to deliver projects on time and within budget.',
  },

];


const BusinessDevelopment = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Business Development</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default BusinessDevelopment
